import { Badge } from "@/components/ui/badge";

type ProjectStatusType = "not_started" | "in_progress" | "on_hold" | "at_risk" | "cancelled" | "completed";
type TaskStatusType = "not_started" | "in_progress" | "on_hold" | "at_risk" | "cancelled" | "completed";
type StatusType = ProjectStatusType | TaskStatusType;

interface StatusBadgeProps {
  status: StatusType;
  variant?: "project" | "task";
}

export default function StatusBadge({ status, variant = "project" }: StatusBadgeProps) {
  const getStatusStyles = (status: StatusType) => {
    switch (status) {
      case "in_progress":
        return "bg-blue-50 text-blue-700 dark:text-blue-300 border-blue-200 dark:bg-blue-950/30 dark:text-blue-400 dark:border-blue-800";
      case "on_hold":
        return "bg-amber-50 text-amber-700 dark:text-amber-300 border-amber-200 dark:bg-amber-950/30 dark:text-amber-400 dark:border-amber-800";
      case "at_risk":
        return "bg-orange-50 text-orange-700 dark:text-orange-300 border-orange-200 dark:bg-orange-950/30 dark:text-orange-400 dark:border-orange-800";
      case "cancelled":
        return "bg-red-50 text-red-700 dark:text-red-300 border-red-200 dark:bg-red-950/30 dark:text-red-400 dark:border-red-800";
      case "completed":
        return "bg-green-50 text-green-700 dark:text-green-300 border-green-200 dark:bg-green-950/30 dark:text-green-400 dark:border-green-800";
      case "not_started":
      default:
        return "bg-muted text-muted-foreground border-border";
    }
  };

  const getStatusLabel = (status: StatusType) => {
    const labels: Record<string, string> = {
      not_started: "Not Started",
      in_progress: "In Progress",
      on_hold: "On Hold",
      at_risk: "At Risk",
      cancelled: "Cancelled",
      completed: "Completed"
    };
    return labels[status] || status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, ' ');
  };

  return (
    <Badge variant="outline" className={`px-1.5 md:px-2 py-0.5 md:py-1 text-[10px] md:text-xs rounded-full whitespace-nowrap ${getStatusStyles(status)}`}>
      {getStatusLabel(status)}
    </Badge>
  );
}
